/**
 * Phase 1 spine — the KPI status type KpiSpine reads, and the info "i"
 * tooltip affordance other KPI surfaces share.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraTooltip } from '@mono/ui-components';
/** Info "i" affordance carrying a KPI's what/how tooltip, shared so trigger
 * behavior never drifts. The padding/negative-margin pair grows the hit
 * target past the 14px glyph. */ export function KpiInfo({ label, tip, testid, dataName }) {
    return /*#__PURE__*/ _jsx(SpecraTooltip, {
        content: tip,
        delayDuration: 150,
        className: "max-w-[240px]",
        children: /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: "-m-1.5 cursor-help p-1.5",
            "aria-label": `About ${label}`,
            "data-testid": testid,
            "data-name": dataName,
            // Stop the click from bubbling into an enclosing clickable
            // ancestor (e.g. a sortable column's header button, or a table
            // row's onRowClick) that would otherwise activate alongside the
            // tooltip trigger.
            onClick: (e)=>e.stopPropagation(),
            children: /*#__PURE__*/ _jsx("span", {
                className: "flex h-3.5 w-3.5 items-center justify-center rounded-full border border-muted-foreground/50 text-[9px] font-bold text-muted-foreground",
                children: "i"
            })
        })
    });
}
